import { render } from "./index.vue?vue&type=template&id=4322ad05"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4322ad05&lang=less"
script.render = render

export default script